/**
 * Canonical customer agent ids + legacy URL aliases (mirror infra/lambdas/shared/agent-ids.js).
 */

const LEGACY_AGENT_ID_ALIASES: Record<string, string> = {
  lynn: 'mia',
  brian: 'mia',
};

export function canonicalAgentId(agentId: string): string {
  const raw = String(agentId || '').trim();
  if (!raw) return '';
  const lower = raw.toLowerCase();
  return LEGACY_AGENT_ID_ALIASES[lower] || raw;
}

export function agentIdsEquivalent(a: string, b: string): boolean {
  const ca = canonicalAgentId(a);
  const cb = canonicalAgentId(b);
  if (!ca || !cb) return false;
  return ca.toLowerCase() === cb.toLowerCase();
}

export function allowlistPermitsAgent(
  allowedAgentIds: string[] | undefined,
  sessionAgentId: string,
): boolean {
  const allowed = Array.isArray(allowedAgentIds)
    ? allowedAgentIds.map((id) => String(id || '').trim()).filter(Boolean)
    : [];
  const id = String(sessionAgentId || '').trim();
  if (!id) return true;
  if (!allowed.length) return false;
  return allowed.some((entry) => agentIdsEquivalent(entry, id));
}
